import { FieldResearch } from '../../types/fieldResearch';

interface Props {
  researches: FieldResearch[];
  selected: FieldResearch | null;
  onSelect: (research: FieldResearch) => void;
}

export default function ResearchSelector({ researches, selected, onSelect }: Props) {
  const active = researches.filter((r) => r.status === 'active');

  return (
    <div>
      {/* Pills de seleção */}
      <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-none">
        {active.map((r) => {
          const isSelected = selected?.id === r.id;
          return (
            <button
              key={r.id}
              type="button"
              onClick={() => onSelect(r)}
              className={`shrink-0 flex items-center gap-2 px-4 py-2.5 rounded-xl border text-sm font-medium transition-all active:scale-95 ${
                isSelected
                  ? 'bg-gradient-to-r from-purple-600/40 to-pink-600/30 border-purple-500/60 text-white shadow-lg shadow-purple-600/10'
                  : 'bg-white/5 border-white/10 text-white/55 hover:bg-white/10 hover:text-white'
              }`}
            >
              <span
                className={`w-2 h-2 rounded-full shrink-0 ${
                  isSelected ? 'bg-purple-400' : 'bg-white/20'
                }`}
              />
              {r.name}
              <span
                className={`px-1.5 py-0.5 rounded text-xs ${
                  isSelected
                    ? 'bg-purple-500/30 text-purple-200'
                    : 'bg-white/8 text-white/35'
                }`}
              >
                {r.category}
              </span>
            </button>
          );
        })}
      </div>

      {/* Descrição da pesquisa selecionada */}
      {selected && (
        <p className="mt-3 text-xs text-white/40 pl-1">{selected.description}</p>
      )}
    </div>
  );
}
